import {
  Box,
  Button,
  FormControl,
  FormGroup,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { displayNo } from "../../../helper/Number";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "@mui/material/Pagination";
import { useEffect, useState } from "react";
import { sagaActions } from "../../../redux/sagas/sagaActions";
import { OREDER_STATUS, ROUTE_PATH } from "../../../helper/Constants";
import { Link } from "react-router-dom";
import { getLocalStorage } from "../../../helper/Storage";
import ConfirmBox from "../../../components/ConfirmBox/ConfirmBox";

const OrderGrid = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const orders = useSelector((state) => state.orders.orders);
  const totalPage = useSelector((state) => state.orders.totalPage);
  const incenses = useSelector((state) => state.incenses.items);
  const spices = useSelector((state) => state.spices.items);

  const [phone, setPhone] = useState("");
  const [orderNo, setOrderNo] = useState("");
  const [state, setState] = useState(OREDER_STATUS.ALL);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState();
  const [selectedChangeState, setSelectedChangeState] = useState();

  const lan = getLocalStorage("userLanguage");

  const [pageNo, setPageNo] = useState(1);

  const handlePageChange = (e, value) => {
    setPageNo(value);
    dispatch({
      type: sagaActions.ORDERS_LOAD_REQUEST,
      data: {
        pageNo: value ?? 1,
        phone: phone,
        orderNo: orderNo,
        status: state,
      },
    });
  };

  const getRowColor = (status) => {
    switch (status) {
      case OREDER_STATUS.ORDERED:
        return "#000000";
      case OREDER_STATUS.PAID:
        return "#06ac21";
      case OREDER_STATUS.PAYMENT_FAILED:
        return "#ff0000";
      case OREDER_STATUS.INTRANSIT:
        return "#889200";
      case OREDER_STATUS.DELIVERED:
        return "#020475";
      case OREDER_STATUS.DELETED:
        return "#353535";
      default:
        return "#ffffff";
    }
  };

  const handleSubmit = () => {
    handlePageChange(undefined, 1);
  };

  const handleEdit = (orderId) => {};

  const handleStateChange = (orderId, orderNo, state) => {
    setSelectedOrderId(orderId);
    setSelectedChangeState(state);
    setConfirmMsg(
      t("confirm.msg.state-change", {
        state: t("my-orders.status." + state.toLowerCase()),
        orderNo: displayNo(orderNo),
      }),
    );
    setConfirmOpen(true);
  };

  const handleConfirm = () => {
    setConfirmOpen(false);
    setPageNo(1);
    dispatch({
      type: sagaActions.ORDERS_STATE_CHANGE_REQUEST,
      data: {
        orderId: selectedOrderId,
        status: selectedChangeState,
      },
    });
  };

  useEffect(() => {
    handlePageChange();
  }, []);

  return (
    <>
      <Grid container>
        <Grid size={{ xs: 12 }}>
          <FormGroup>
            <Grid
              size={{ xs: 12 }}
              sx={{ padding: "5px", paddingTop: "15px" }}
              container
            >
              <Grid size={{ md: 2, xs: 6 }}>
                <FormControl
                  sx={{
                    display: "inline-block",
                    paddingBottom: "15px",
                    padding: "5px",
                  }}
                >
                  <InputLabel htmlFor="phone">
                    {t("my-orders.phone")}
                  </InputLabel>
                  <Input
                    required
                    id="phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </FormControl>
              </Grid>
              <Grid size={{ md: 2, xs: 6 }}>
                <FormControl
                  sx={{
                    display: "inline-block",
                    paddingBottom: "15px",
                    padding: "5px",
                  }}
                >
                  <InputLabel htmlFor="orderNo">
                    {t("my-orders.order-no")}
                  </InputLabel>
                  <Input
                    required
                    id="orderNo"
                    value={orderNo}
                    onChange={(e) => setOrderNo(e.target.value)}
                  />
                </FormControl>
              </Grid>
              <Grid size={{ md: 2, xs: 6 }}>
                <FormControl
                  sx={{
                    paddingBottom: "15px",
                    padding: "5px",
                    border: "none",
                  }}
                  className="w-full"
                >
                  <InputLabel id="state-label" htmlFor="state">
                    {t("my-orders.status")}
                  </InputLabel>
                  <Select
                    labelId="state-label"
                    id="lang-select"
                    value={state}
                    label="state"
                    onChange={(e) => {
                      setState(e.target.value);
                    }}
                    sx={{
                      padding: "7px",
                    }}
                  >
                    <MenuItem value={OREDER_STATUS.ALL}>
                      {t("my-orders.status.all")}
                    </MenuItem>
                    <MenuItem value={OREDER_STATUS.ORDERED}>
                      {t("my-orders.status.ordered")}
                    </MenuItem>
                    <MenuItem value={OREDER_STATUS.PAID}>
                      {t("my-orders.status.paid")}
                    </MenuItem>
                    <MenuItem value={OREDER_STATUS.PAYMENT_FAILED}>
                      {t("my-orders.status.payment_failed")}
                    </MenuItem>
                    <MenuItem value={OREDER_STATUS.INTRANSIT}>
                      {t("my-orders.status.intransit")}
                    </MenuItem>
                    <MenuItem value={OREDER_STATUS.DELIVERED}>
                      {t("my-orders.status.delivered")}
                    </MenuItem>
                    <MenuItem value={OREDER_STATUS.DELETED}>
                      {t("my-orders.status.deleted")}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ md: 1, xs: 6 }} sx={{ padding: "5px 0" }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  className="w-full"
                  sx={{ padding: "10px 0" }}
                >
                  {t("submit")}
                </Button>
              </Grid>
            </Grid>
          </FormGroup>
        </Grid>
        <Grid sx={{ padding: "5px" }} size={{ xs: 12 }} className="container">
          {[...orders]?.map((order, index) => (
            <Grid
              container
              key={"order_" + index}
              sx={{
                padding: 1,
                textAlign: "center",
                color: getRowColor(order.status),
                marginBottom: "5px",
              }}
              className="row"
            >
              <Grid size={{ sm: 3, md: 1, xs: 4 }} sx={{ textAlign: "left" }}>
                {(order.status === OREDER_STATUS.ORDERED ||
                  order.status === OREDER_STATUS.PAYMENT_FAILED) && (
                  <Button
                    className="w-full m-1"
                    variant="contained"
                    onClick={() => handleEdit(order.id)}
                  >
                    {t("my-orders.edit")}
                  </Button>
                )}
                {order.status !== OREDER_STATUS.DELETED && (
                  <Button
                    className="w-full m-1"
                    variant="contained"
                    onClick={() =>
                      handleStateChange(
                        order.id,
                        order.orderNo,
                        OREDER_STATUS.DELETED,
                      )
                    }
                  >
                    {t("my-orders.delete")}
                  </Button>
                )}
                {(order.status === OREDER_STATUS.ORDERED ||
                  order.status === OREDER_STATUS.PAYMENT_FAILED) && (
                  <Button
                    className="w-full m-1"
                    variant="contained"
                    onClick={() =>
                      handleStateChange(
                        order.id,
                        order.orderNo,
                        OREDER_STATUS.PAID,
                      )
                    }
                  >
                    {t("my-orders.paid")}
                  </Button>
                )}
                {(order.status === OREDER_STATUS.ORDERED ||
                  order.status === OREDER_STATUS.PAYMENT_FAILED) && (
                  <Button
                    className="w-full m-1"
                    variant="contained"
                    onClick={() =>
                      handleStateChange(
                        order.id,
                        order.orderNo,
                        OREDER_STATUS.PAYMENT_FAILED,
                      )
                    }
                  >
                    {t("my-orders.payment-failed")}
                  </Button>
                )}

                {order.status === OREDER_STATUS.PAID && (
                  <Button
                    className="w-full m-1"
                    variant="contained"
                    onClick={() =>
                      handleStateChange(
                        order.id,
                        order.orderNo,
                        OREDER_STATUS.INTRANSIT,
                      )
                    }
                  >
                    {t("my-orders.in-transit")}
                  </Button>
                )}

                {order.status === OREDER_STATUS.INTRANSIT && (
                  <Button
                    className="w-full m-1"
                    variant="contained"
                    onClick={() =>
                      handleStateChange(
                        order.id,
                        order.orderNo,
                        OREDER_STATUS.DELIVERED,
                      )
                    }
                  >
                    {t("my-orders.delivered")}
                  </Button>
                )}
              </Grid>
              <Grid
                size={{ sm: 9, md: 2, xs: 8 }}
                sx={{ textAlign: "left", padding: "5px" }}
              >
                <Typography>
                  <strong>{t("my-orders.orderNo")}: </strong>
                  {displayNo(order?.orderNo)}
                </Typography>
                <Typography>
                  <strong>{t("my-orders.phone")}: </strong>{" "}
                  {displayNo(order?.phone)}
                </Typography>
                <Typography>
                  <strong>{t("my-orders.address")}: </strong>
                  {order?.address}
                </Typography>
                <Typography>
                  <strong>{t("my-orders.status")}: </strong>
                  {t("my-orders.status." + order?.status.toLowerCase())}
                </Typography>
                <Typography>
                  <strong>{t("my-orders.comments")}: </strong> {order?.comments}
                </Typography>
                <Typography>
                  <strong>{t("my-orders.created")}: </strong>{" "}
                  {displayNo(order?.createOn)}
                </Typography>
                <Typography>
                  <strong>{t("my-orders.updated")}: </strong>{" "}
                  {displayNo(order?.updateOn)}
                </Typography>
              </Grid>
              <Grid
                size={{ sm: 12, md: 7, xs: 12 }}
                sx={{ borderTop: "1px solid #ababab50" }}
              >
                {order?.items.map((item) => {
                  const product =
                    item.type === ROUTE_PATH.INCENSES
                      ? incenses.filter(
                          (incense) => incense.id === item.itemId,
                        )[0]
                      : spices.filter((spice) => spice.id === item.itemId)[0];
                  return (
                    <Grid
                      container
                      key={item.id}
                      sx={{
                        padding: "5px",
                        borderBottom: "1px solid #ababab50",
                      }}
                    >
                      <Grid
                        size={{ md: 2, xs: 4 }}
                        sx={{
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        <Link
                          to={
                            "/" +
                            ROUTE_PATH.PRODUCT_DETAILS +
                            item.itemId +
                            "/" +
                            item.type
                          }
                          style={{ textAlign: "left" }}
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL + product?.thumbnail
                            }
                            alt={product?.thumbnail}
                            className="checkout-img"
                          ></img>
                        </Link>
                      </Grid>
                      <Grid size={{ md: 10, xs: 8 }} container>
                        <Grid
                          size={{ lg: 4 }}
                          sx={{ padding: "5px", textAlign: "left" }}
                        >
                          {product?.name.find((n) => n.key === lan)?.value}
                        </Grid>
                        <Grid
                          size={{ lg: 5 }}
                          sx={{ padding: "5px", textAlign: "left" }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              fontWeight: "bold",
                              padding: "0 3px",
                              fontSize: "15px",
                            }}
                          >
                            ₹{displayNo(Number(item.offerPrice).toFixed(2))}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              textDecoration: "line-through",
                              color: "#888888ff",
                            }}
                          >
                            ₹{displayNo(Number(item.actualPrice).toFixed(2))}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              fontWeight: "bold",
                              padding: "0 3px",
                              color: "#28d311ff",
                            }}
                          >
                            {displayNo(
                              (
                                (100 * (item.actualPrice - item.offerPrice)) /
                                item.actualPrice
                              ).toFixed(2),
                            )}
                            %{t("off")}
                          </Typography>
                        </Grid>
                        <Grid
                          size={{ lg: 1 }}
                          sx={{
                            padding: "5px",
                          }}
                        >
                          <Typography
                            sx={{
                              textAlign: "left",
                              minWidth: "35px",
                            }}
                          >
                            {" x "}
                            {displayNo(item.count.toString())}
                            {" = "}
                          </Typography>
                        </Grid>
                        <Grid
                          size={{ lg: 2 }}
                          sx={{
                            padding: "5px",
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              fontWeight: "bold",
                              padding: "0 3px",
                              fontSize: "15px",
                            }}
                          >
                            ₹
                            {displayNo(
                              Number(item.offerPrice * item.count).toFixed(2),
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
              <Grid
                size={{ sm: 12, md: 2, xs: 12 }}
                sx={{ textAlign: "left", padding: "5px" }}
              >
                <Box variant="span" sx={{ padding: "10px 20px 10px 0" }}>
                  {t("my-orders.item-total")}: ₹{" "}
                  {displayNo(
                    order?.items
                      ?.reduce(
                        (a, v) =>
                          (a =
                            parseFloat(a) +
                            parseFloat(v.offerPrice) * parseFloat(v.count)),
                        0,
                      )
                      .toFixed(2),
                  )}
                </Box>
                <Box variant="span" sx={{ padding: "10px 20px 10px 0" }}>
                  {t("my-orders.delivery-fee")}: ₹{" "}
                  {displayNo(parseFloat(order?.deliveryFee).toFixed(2))}
                </Box>
                <Box variant="span" sx={{ padding: "10px 20px 10px 0" }}>
                  {t("my-orders.discount")}: ₹{" "}
                  {displayNo(parseFloat(order?.discount).toFixed(2))}
                </Box>
                <Typography
                  variant="h7"
                  sx={{ padding: "10px 20px 10px 0", fontWeight: "bold" }}
                >
                  {t("my-orders.grand-total")}: ₹{" "}
                  {displayNo(
                    (
                      order?.items.reduce(
                        (a, v) =>
                          (a =
                            parseFloat(a) +
                            parseFloat(v.offerPrice) * parseFloat(v.count)),
                        0,
                      ) +
                      parseFloat(order?.deliveryFee) -
                      parseFloat(order?.discount)
                    ).toFixed(2),
                  )}
                </Typography>
              </Grid>
            </Grid>
          ))}
          {totalPage > 0 && (
            <Pagination
              count={totalPage}
              page={pageNo}
              color="primary"
              onChange={handlePageChange}
            />
          )}
        </Grid>
      </Grid>
      <ConfirmBox
        open={confirmOpen}
        handleClose={() => {
          setConfirmOpen(false);
        }}
        confirmMsg={confirmMsg}
        handleConfirm={handleConfirm}
      />
    </>
  );
};

export default OrderGrid;
